import apiClient from "@/axiosConfig";

function route(kind) {
  if (!["article", "customer", "company"].includes(kind)) throw new Error("Unbekannter Importbereich.");
  return `/${kind}/import`;
}

export default {
  preview(kind, input) { return apiClient.post(`${route(kind)}/preview`, input); },
  apply(kind, input) { return apiClient.post(`${route(kind)}/apply`, input); },
};
